import Vue from 'vue'
import App from './App'
import router from './router'
import { Timepicker } from 'buefy'
import 'buefy/dist/buefy.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

import ClockIn from './components/ClockInComponent.vue'
import ClockOut from './components/ClockOutComponent.vue'
import RecoveryForm from './components/RecoveryModeFormComponent.vue'
import DisclaimerDialog from './components/DisclaimerDialog.vue'
import NoticeAlert from './components/NoticeAlert.vue'
import AddLoadDialog from './components/AddLoadDialog.vue'
import NewHolidayRequestDialog from './components/NewHolidayRequestDialog.vue'
import EditHolidayRequestDialog from './components/EditHolidayRequestDialog.vue'
import AnotherHolidayRequestDialog from './components/AnotherHolidayRequestDialog.vue'
import SchengenRequest from './components/SchengenRequest.vue'
import EditSchengenRequest from './components/EditSchengenRequest.vue'

require('./assets/css/materialdesignicons.min.css')
require('./assets/flag-images/css/flags.css')

Vue.use(Vuetify, {
  theme: {
    primary: '#1E2D4F',
    secondary: '#50C3F9',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.use(Timepicker)

Vue.component('Clock-In', ClockIn)
Vue.component('Clock-Out', ClockOut)
Vue.component('Recovery-Form', RecoveryForm)
Vue.component('Disclaimer-Dialog', DisclaimerDialog)
Vue.component('Add-Load-Dialog', AddLoadDialog)
Vue.component('New-Holiday-Request-Dialog', NewHolidayRequestDialog)
Vue.component('Edit-Holiday-Request-Dialog', EditHolidayRequestDialog)
Vue.component('Another-Holiday-Request-Dialog', AnotherHolidayRequestDialog)
Vue.component('Schengen-Request', SchengenRequest)
Vue.component('Edit-Schengen-Request', EditSchengenRequest)
Vue.component('Notice-Alert', NoticeAlert)
Vue.config.productionTip = false

const datepickerOptions = {
  colors: {
    selected: '#337ab7',
    inRange: '#429ded',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#3378b5',
    disabled: '#fff'
  }
}
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    let company = localStorage.getItem('company') !== null && localStorage.getItem('company') !== undefined ? localStorage.company : null
    this.$store.dispatch('checkCompany', company)
    let url = localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com'
    this.$store.dispatch('setURL', url)
    firebase.auth().signOut() // Make sure we don't have a user authenticated with firebase initially
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        console.log('Authenticated with firebase, uid = ' + user.uid)
        // ...
      } else {
        console.log('Unauthenticated from firebase')
        if (!this.$router.currentRoute.path.includes('signin')) {
          this.$router.push('/signin')
        }
      // User is signed out.
      // ...
      }
      if (this.$router.currentRoute.path.includes('signin/')) {
        window.addEventListener('visibilitychange', () => {
          if (!document.hidden && this.$router.currentRoute.path.indexOf('Expenses') === -1) {
            window.location.reload()
          }
        })
      }
    })
    firebase.database().ref('appData/versions').once('value')
      .then(result => {
        const latestVersions = result.val()
        if (localStorage.getItem('db-version')) {
          const currentDbVersion = localStorage.getItem('db-version')
          if (latestVersions.db !== currentDbVersion) {
            console.log('Database outdated, clearing local storage')
            localStorage.removeItem('languages')
            localStorage.removeItem('disclaimerText')
            localStorage.setItem('db-version', latestVersions.db)
          }
        }
        if (latestVersions.app !== this.appVersion) {
          console.log('App outdated, need to update')
          this.$store.dispatch('appOutdated', true)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  data () {
    return {
      appVersion: '0.10.75'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js